var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { alertState } from "@recoil/assessmentState";
import { reloadSpg, userInfoLoginState } from "@recoil/userState";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { jsclose_AlertErrorPopup, jsclose_Popup, jsopen_AlertPopup } from "@utils/commUtils";
import { API_200, POP_ALERT, TYPE_INNRE, TYPE_NONE } from "@utils/Const";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
const DeletePop = (props) => {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setReloadspg = useSetRecoilState(reloadSpg);
    //props
    const { comment, appPath, checkItem, setCheckItem, setCheckArr, handleCurPage, closePopup } = props;
    const deleteProposal = () => __awaiter(void 0, void 0, void 0, function* () {
        let data;
        let success = [];
        let fail = [];
        for (const item of checkItem) {
            data = yield PromiseHttp({
                httpMethod: "DELETE",
                appPath: `${appPath}${item.id}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            }).then((res) => {
                if (res.codeNum === API_200) {
                    success.push(res);
                }
                else {
                    fail.push(res);
                }
                return res;
            });
        }
        if (data) {
            if (success.length > 0) {
                jsclose_Popup("pop-delete");
                setReloadspg(true);
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: TYPE_INNRE, divTag: "삭제 되었습니다" }));
                jsopen_AlertPopup(POP_ALERT);
                setCheckArr([]);
                setCheckItem([]);
                handleCurPage(0);
            }
            else {
                // need error handle
                if (data.errorList.field((err) => err.field == "itemId").length > 0) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: TYPE_NONE, divTag: "삭제를 실패했습니다", callBack: () => {
                            jsclose_AlertErrorPopup(POP_ALERT);
                        } }));
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: TYPE_NONE, divTag: "500 Internal Server Error", callBack: () => {
                            jsclose_AlertErrorPopup(POP_ALERT);
                        } }));
                }
                jsopen_AlertPopup(POP_ALERT);
            }
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "popup-layer js-layer popup-basic" }, { children: [_jsx("div", Object.assign({ className: "popup__head" }, { children: _jsx("h1", Object.assign({ className: "popup__title" }, { children: "\uC0AD\uC81C" })) })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: comment }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: () => closePopup() }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: () => {
                                {
                                    closePopup();
                                    deleteProposal();
                                }
                            } }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
};
export default DeletePop;
